export default __webpack_public_path__ + "static/media/not_to_standard_icon.f65f6ff7.png";